// Countries allowed to download each product, per region.
// Codes are the lowercase values of the ROC `country` cookie.
// A region that is not listed for a product has no country restriction for that product.
// A country can be in both lists (it can download both) or in neither (it is blocked).

// ResScan (full software)
const RESSCAN_ALLOWED_COUNTRIES = {
  "en-ap": [
    "idn", // Indonesia
    "mys", // Malaysia
    "phl", // Philippines
    "roca", // Rest of China Area
    "sgp", // Singapore
    "kor", // South Korea
    "twn", // Taiwan is restricting now downloading the document
    "tha", // Thailand
    "vnm", // Vietnam
    "mac", // Macau
    "myr", // Myanmar
    "las", // Laos
    "cbd", // Cambodia
    "brn", // Brunei
  ],
  "es-xl": [
    "lat", // Latin America
    "arg", // Argentina
    "bez", // Belize
    "bol", // Bolivia
    "chi", // Chile
    "col", // Colombia
    "cos", // Costa Rica
    "cub", // Cuba
    "dor", // Dominican Republic
    "ecu", // Ecuador
    "els", // El Salvador
    "fgd", // French Guiana
    "gdl", // Guadeloupe
    "gtm", // Guatemala
    "guy", // Guyana
    "hai", // Haiti
    "hon", // Honduras
    "mrt", // Martinique
    "mex", // Mexico
    "nic", // Nicaragua
    "pan", // Panama
    "par", // Paraguay
    "per", // Peru
    "pur", // Puerto Rico
    "sab", // Saint-Barthelemy
    "sam", // Saint-Martin
    "sur", // Suriname
    "uru", // Uruguay
    "ven", // Venezuela
  ],
};

// ResScan Essentials
const RESSCAN_ESSENTIALS_ALLOWED_COUNTRIES = {
  "en-ap": [
    "hkg", // Hong Kong
  ],
  "es-xl": [
    "arg", // Argentina
    "col", // Colombia
    "chi", // Chile
    "hon", // Honduras
    "per", // Peru
    "uru", // Uruguay
    "par", // Paraguay
    "cos", // Costa Rica
    "gtm", // Guatemala
    "pur", // Puerto Rico
  ],
};

function isCountryAllowed(allowedCountriesByRegion, regionCode, countryCode) {
  const normalizedRegion = (regionCode || "").toLowerCase().trim();

  // Region without a list: no country restriction
  if (
    !Object.prototype.hasOwnProperty.call(
      allowedCountriesByRegion,
      normalizedRegion
    )
  ) {
    return true;
  }

  const normalizedCountry = (countryCode || "").toLowerCase().trim();

  // Restricted region but no country: deny
  if (!normalizedCountry) {
    return false;
  }

  return allowedCountriesByRegion[normalizedRegion].includes(normalizedCountry);
}

function isCountryAllowedForResScan(regionCode, countryCode) {
  return isCountryAllowed(RESSCAN_ALLOWED_COUNTRIES, regionCode, countryCode);
}

function isCountryAllowedForResScanEssentials(regionCode, countryCode) {
  return isCountryAllowed(
    RESSCAN_ESSENTIALS_ALLOWED_COUNTRIES,
    regionCode,
    countryCode
  );
}

module.exports = {
  RESSCAN_ALLOWED_COUNTRIES,
  RESSCAN_ESSENTIALS_ALLOWED_COUNTRIES,
  isCountryAllowedForResScan,
  isCountryAllowedForResScanEssentials,
};

module.exports.default = module.exports;
